import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import image from '../assets/images/image_1.png';
import image1 from '../assets/images/image_2.png';
import style from '../css/Card_one.module.css';
import OurPartner from './OurPartner';

function useScrollReveal(ref) {
	useEffect(() => {
		const el = ref.current;
		if (!el) return;

		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					el.classList.add(style.cardVisible);
					observer.unobserve(el); // Animate only once
				}
			},
			{ threshold: 0.2 }
		);

		observer.observe(el);
		return () => observer.disconnect();
	}, [ref]);
}

function Card_one() {
	const card1Ref = useRef(null);
	const card2Ref = useRef(null);

	useScrollReveal(card1Ref);
	useScrollReveal(card2Ref);

	return (
		<div className={style.container}>
			{/* one */}
			<div
				ref={card1Ref}
				className={`${style.cardWrapper} ${style.cardReveal}`}
			>
				<div className={style.leftContent}>
					<p className={style.smallHeading}>Exporest Travel</p>
					<h2 className={style.title}>Travel Made Easy</h2>
					<p className={style.description}>
						Simplify corporate travel management. Exporest’s intuitive platform
						empowers employees to book from an extensive inventory while staying
						within your company’s spending limits.
					</p>
					<Link to="#" className={style.linkButton}>
						Learn more about Exporest Travel
					</Link>
				</div>
				<div className={style.rightImage}>
					<img src={image} alt="Exporest Travel App" className={style.image} />
				</div>
			</div>
			<OurPartner />

			{/* two */}
			<div
				ref={card2Ref}
				className={`${style.cardWrapper} ${style.cardReveal}`}
			>
				<div className={style.rightImage}>
					<img src={image1} alt="Exporest Travel App" className={style.image} />
				</div>
				<div className={style.leftContent}>
					<p className={style.smallHeading}>Exporest Travel</p>
					<h2 className={style.title}>Spend Smarter</h2>
					<p className={style.description}>
						Streamline your expense management from swipe to reconciliation.
						Automate categorization, reports, and reimbursements. Boost
						productivity and optimize savings with AI-powered insights.
					</p>
					<Link to="#" className={style.linkButton}>
						Learn more about Exporest Travel
					</Link>
				</div>
			</div>
		</div>
	);
}

export default Card_one;
